import Vue from 'vue'
import VueI18n from 'vue-i18n'
import kaz from './kz'
import eng from './en'
import rus from './ru'

Vue.use(VueI18n)

const messages = {
    ru: rus,
    kz: kaz,
    en: eng
}

const defaultFormat = {
    short: {
        year: 'numeric', month: 'numeric', day: 'numeric'
    },
    long: {
        year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short'
    },
    longTime: {
        year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
    }
}
const dateTimeFormats = {
    ru: defaultFormat,
    en: defaultFormat,
    kz: defaultFormat
}

export default new VueI18n({
    locale: 'ru',
    fallbackLocale: 'ru',
    messages,
    dateTimeFormats
})
